import { REDUX_LOCAL_KEY } from '../../../redux/constants/local-key'

export const PLAN_KEY = {
  ID: 'id',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  CLASS_NAME: 'className',

  NAME: 'name',
  CHALLENGE: 'challenge',
  LEVEL: 'level',
  DIFFICULTY: 'difficulty',
  NOTES: 'notes',
  INSTRUCTIONS: 'instructions',
  STARTED_AT: 'startedAt',
  LOGGED_AT: 'loggedAt',
  FEATURED_AT: 'featuredAt',
  RECOMMENDED_AT: 'recommendedAt',
  SUGGESTED_AT: 'suggestedAt',

  RATING: 'rating',
  REVIEW_COUNT: 'reviewCount',
  DAYS_COUNT: 'daysCount',
  DAYS_COMPLETED_COUNT: 'daysCompletedCount',
  COMPLETED_COUNT: 'completedCount',
  STARTED_COUNT: 'startedCount',
  TRENDING_AT: 'trendingAt',

  WEEKS_COUNT: 'weeksCount',
  WORKOUTS_COUNT: 'workoutsCount',
  WORKOUTS_COMPLETED_COUNT: 'workoutsCompletedCount',
  EQUIPMENT: 'equipment',
  MUSCLES: 'muscles',
  SECONDARY_MUSCLES: 'secondaryMuscles',
  TYPES: 'types',
  IMAGE: 'image',
  WELCOME_MEDIA_TITLE: 'welcomeMediaTitle',

  // Associations
  MEDIA: 'media',
  WELCOME_MEDIA: 'welcomeMedia',
  WORKOUTS: 'workouts',
  DAYS: 'days',
  TAGS: 'tags',

  // Foreign keys
  MEDIA_ID: 'mediaId',
  WELCOME_MEDIA_ID: 'welcomeMediaId',
  PROFILE_ID: 'profileId',
  AUTHOR_ID: 'authorId',
  PARENT_ID: 'parentId',
  ORIGINAL_PARENT_ID: 'originalParentId',

  // Local -- not understood by the server
  HAS_ASSOCIATION_CHANGE: REDUX_LOCAL_KEY.HAS_ASSOCIATION_CHANGE,
  LOCAL_IS_DOWNLOADED: REDUX_LOCAL_KEY.IS_DOWNLOADED,
  LOCAL_IS_SUGGESTED: REDUX_LOCAL_KEY.IS_SUGGESTED,
  LOCAL_ADD_WORKOUTS_SUGGESTED_AT: '__localAddWorkoutsSuggestedAt',
  LOCAL_START_AT: '__localStartAt',

  // Frontend
  PRICE: 'price',

  // Remote -- sent by the server
  // Non-premium customer or non-purchased plan
  REMOTE_IS_PREVIEW: '__remoteIsPreview',
  MY_PLAN_ID: 'myPlanId',
  MY_PLAN_PROFILE: 'myPlanProfile',
  PROFILES_WHO_STARTED: 'profilesWhoStarted',

  // Creator
  STRIPE_PRODUCT: 'stripeProduct',
  STRIPE_PRICE: 'stripePrice',
  CREATOR_PLAN_STRIPE_PRODUCT: 'creatorPlanStripeProduct'

}

export const PLAN_CLASS_NAME = 'Plan'

export const PLAN_ASSOCIATION_KEYS = [
  PLAN_KEY.WORKOUTS,
  PLAN_KEY.DAYS,
  PLAN_KEY.WELCOME_MEDIA,
  PLAN_KEY.MEDIA,
  PLAN_KEY.PROFILES_WHO_STARTED,
  PLAN_KEY.TAGS
]

export const PLAN_AUDIT = {
  CREATED: 'Plan Created',
  COPIED: 'Plan Copied',
  DELETED: 'Plan Deleted',
  UPDATED: 'Plan Updated',
  LOGGED: 'Plan Logged'
}
//
// export const PLAN_FOREIGN_KEYS = [
//   PLAN_KEY.AUTHOR_ID,
//   PLAN_KEY.PROFILE_ID,
//   PLAN_KEY.PARENT_ID,
//   PLAN_KEY.ORIGINAL_PARENT_ID
// ]

export const PLAN_PRIVATE_KEYS = []

export const PLAN_SCOPE = {
  /**
   * Only returns the public attributes.
   * @type {Object}
   */
  defaultScope: {
    attributes: {
      exclude: PLAN_PRIVATE_KEYS
    }
  }
}

export const PLAN_SHALLOW_KEYS = [
  PLAN_KEY.NAME,
  PLAN_KEY.IMAGE,
  PLAN_KEY.WEEKS_COUNT,
  PLAN_KEY.WORKOUTS_COUNT,
  PLAN_KEY.LOGGED_AT
]

export const PLAN_LOCAL_KEYS = [
  REDUX_LOCAL_KEY.HAS_ASSOCIATION_CHANGE,
  REDUX_LOCAL_KEY.IS_SUGGESTED,
  REDUX_LOCAL_KEY.IS_DOWNLOADED
]
